<template>
  <section id="sectores" class="neftysGradient">
    <v-container fluid fill-height class="container py-15">
      <v-row
        justify="center"
        align="center"
        class="d-flex align-center justify-center py-5"
      >
        <v-col align="center" cols="10" md="5">
          <p
            id="titulo"
            v-scrollanimation
            class="neftysBlue--text text-center text-h4 text-md-h3 mb-15"
          >
            {{ $t("sectores.definicion") }}
          </p>
        </v-col>

        <v-col cols="11" align="center">
          <v-row align="start" justify="center">
            <!-- COMPAÑIA -->
            <v-col
              v-scrollanimation
              cols="12"
              md="3"
              class="anim d-flex justify-center"
            >
              <v-card
                width="300"
                elevation="0"
                class="rounded-xl px-2"
                color="transparent"
              >
                <v-img
                  src="@/assets/img/neftys/sectores/pets.png"
                  width="300"
                  height="300"
                  contain
                  class="rounded-xl"
                >
                </v-img>

                <div>
                  <h3 class="display-1 mx-5 neftysBlue--text text-center">
                    {{ $t("sectores.animales") }}
                  </h3>
                  <v-row align="center" justify="center" class="mt-3">
                    <v-col class="d-flex align-center justify-center">
                      <v-card-actions>
                        <v-btn
                          color="accent"
                          @click="reveal1 = true"
                          rounded
                          width="100"
                        >
                          + info
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>

                  <v-expand-transition>
                    <v-card
                      v-if="reveal1"
                      class="v-card--reveal rounded-xl"
                      style="height: 100%; width: 100%"
                      color="bg-white"
                      elevation="0"
                    >
                      <v-card-text
                        class="pb-0 pt-2 d-flex align-start"
                        style="height: 90%; width: 100%"
                      >
                        <div class="d-flex align-center transparent">
                          <v-list class="transparent rounded-xl ma-0 pa-0">
                            <p class="mx-1 text-left accent--text">
                              {{ $t("sectores.animalestext5") }}
                              <strong>{{
                                $t("sectores.animalestext6")
                              }}</strong>
                            </p>
                            <p class="mx-1 text-left font-weight-medium">
                              {{ $t("sectores.animalestext7") }}
                            </p>
                            <p class="mx-1 text-left font-weight-medium">
                              {{ $t("sectores.animalestext8") }}
                            </p>
                          </v-list>
                        </div>
                      </v-card-text>
                      <v-card-actions class="d-flex justify-center bottom-button">
                        <v-btn
                          color="accent"
                          elevation="0"
                          @click="reveal1 = false"
                          bottom
                          dark
                          fab
                          small
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expand-transition>
                </div>
              </v-card>
            </v-col>
            <!-- PRODUCCION -->
            <v-col
              v-scrollanimation
              cols="12"
              md="3"
              class="anim d-flex justify-center"
            >
              <v-card
                max-width="300"
                min-width="225"
                min-height="390"
                max-height="500"
                elevation="0"
                class="rounded-xl px-2"
                color="transparent"
              >
                <v-img
                  src="@/assets/img/neftys/sectores/pig.png"
                  width="300"
                  height="300"
                  contain
                  class="rounded-xl"
                >
                </v-img>

                <div>
                  <h3 class="display-1 mx-5 neftysBlue--text text-center">
                    {{ $t("sectores.produccion") }}
                  </h3>
                  <v-row align="center" justify="center" class="mt-3">
                    <v-col class="d-flex align-center justify-center">
                      <v-card-actions>
                        <v-btn
                          color="accent"
                          @click="reveal2 = true"
                          rounded
                          width="100"
                        >
                          + info
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>

                  <v-expand-transition>
                    <v-card
                      v-if="reveal2"
                      class="transition-fast-in-fast-out v-card--reveal rounded-xl bg-white mx-auto"
                      style="height: 100%; width: 100%"
                      elevation="0"
                    >
                      <v-card-text style="height: 90%" class="pb-0 pt-3">
                        <v-list
                          class="bg-white ma-0 pa-0"
                        >
                          <p
                            class="mx-1 text-center accent--text font-weight-bold"
                          >
                            {{ $t("sectores.producciontext0") }}
                          </p>
                          <v-list-item-group
                            v-for="(item, i) in produccion"
                            :key="i"
                            class="d-flex justify-start align-start pa-0 my-3"
                          >
                            <v-list-item-icon
                              class="d-flex align-start pt-1 ma-0"
                            >
                              <v-icon size="8">{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content
                              class="d-flex align-start pa-0 ma-0"
                            >
                              <v-list-item-subtitle
                                class="text-left text-wrap font-weight-medium ma-0"
                              >
                                {{ $t(`${item.title}`) }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item-group>
                        </v-list>
                      </v-card-text>
                      <v-card-actions class="d-flex justify-center bottom-button">
                        <v-btn
                          color="accent"
                          elevation="0"
                          @click="reveal2 = false"
                          bottom
                          dark
                          fab
                          small
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expand-transition>
                </div>
              </v-card>
            </v-col>
            <!-- AVICOLA -->
            <v-col
              v-scrollanimation
              cols="12"
              md="3"
              class="anim d-flex justify-center"
            >
              <v-card
                width="300"
                elevation="0"
                class="rounded-xl px-2"
                color="transparent"
              >
                <v-img
                  src="@/assets/img/neftys/sectores/avicola.png"
                  width="300"
                  height="300"
                  contain
                  class="rounded-xl"
                >
                </v-img>

                <div>
                  <v-row align="center" justify="center" class="mt-3">
                    <h3 class="display-1 mx-5 neftysBlue--text text-center my-5">
                      {{ $t("sectores.avicultura") }}
                    </h3>
                    <v-col class="d-flex align-center justify-center">
                      <v-card-actions>
                        <v-btn
                          color="accent"
                          @click="reveal3 = true"
                          rounded
                          width="100"
                        >
                          + info
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                  <v-expand-transition>
                    <v-card
                      v-if="reveal3"
                      class="transition-fast-in-fast-out v-card--reveal rounded-xl mx-auto"
                      style="height: 100%; width: 100%"
                      color="bg-white"
                      elevation="0"
                    >
                      <v-card-text style="height: 90%" class="pb-0 pt-3">
                        <v-list
                          class="bg-white ma-0 pa-0"
                        >
                          <p
                            class="mx-1 text-center font-weight-bold accent--text"
                          >
                            {{ $t("sectores.aviculturatext1") }}
                            <!-- <strong
                              class="mx-1 text-center font-weight-medium accent--text"
                              >{{ $t("sectores.aviculturatext2") }}</strong
                            > -->
                          </p>
                          <v-list-item-group
                            v-for="(item, i) in avicultura"
                            :key="i"
                            class="d-flex justify-start align-start pa-0 my-3"
                          >
                            <v-list-item-icon
                              class="d-flex align-start pt-1 ma-0"
                            >
                              <v-icon size="8">{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content
                              class="d-flex align-start pa-0 ma-0"
                            >
                              <v-list-item-subtitle
                                class="text-left text-wrap font-weight-medium ma-0"
                              >
                                {{ $t(`${item.title}`) }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item-group>
                        </v-list>
                      </v-card-text>
                      <v-card-actions class="d-flex justify-center bottom-button">
                        <v-btn
                          color="accent"
                          elevation="0"
                          @click="reveal3 = false"
                          bottom
                          dark
                          fab
                          small
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expand-transition>
                </div>
              </v-card>
            </v-col>
            <!-- BIOSEGURIDAD -->
            <v-col
              v-scrollanimation
              cols="12"
              md="3"
              class="anim d-flex justify-center"
            >
              <v-card
                width="300"
                elevation="0"
                class="rounded-xl px-2"
                color="transparent"
              >
                <v-img
                  src="@/assets/img/neftys/sectores/bioseguridad.png"
                  width="300"
                  height="300"
                  contain
                  class="rounded-xl"
                >
                </v-img>

                <div>
                  <v-row align="center" justify="center" class="mt-3">
                    <p class="display-1 mx-5 neftysBlue--text text-center my-5">
                      {{ $t("sectores.bioseguridad") }}
                    </p>
                    <v-col class="d-flex align-center justify-center">
                      <v-card-actions>
                        <v-btn
                          color="accent"
                          @click="reveal4 = true"
                          rounded
                          width="100"
                        >
                          + info
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                  <v-expand-transition>
                    <v-card
                      v-if="reveal4"
                      class="transition-fast-in-fast-out v-card--reveal rounded-xl mx-auto"
                      style="height: 100%; width: 100%"
                      color="bg-white"
                      elevation="0"
                    >
                      <v-img contain>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="106.09"
                          height="68.613"
                          viewBox="0 0 106.09 68.613"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <path
                                id="Trazado_59651"
                                data-name="Trazado 59651"
                                d="M646.365-883.192c-1.491,2.249-2.863,4.576-4.412,6.786-.376.537-.757,1.068-1.129,1.607a5.948,5.948,0,0,0-.635.943c-.182.458-.155.267.155.7a26.388,26.388,0,0,0,2.028,2.3c2.488,2.685,5.812,4.117,8.995,5.852a.3.3,0,0,0,.441-.257,25.259,25.259,0,0,0-.549-7.4c-.464-1.711-.944-3.426-1.534-5.1a27.383,27.383,0,0,0-2.857-5.414.3.3,0,0,0-.253-.139.3.3,0,0,0-.25.133"
                                fill="none"
                              />
                            </clipPath>
                            <clipPath id="clip-path-2">
                              <rect
                                id="Rectángulo_319"
                                data-name="Rectángulo 319"
                                width="13.881"
                                height="20.374"
                                transform="translate(639.027 -884.349)"
                                fill="none"
                              />
                            </clipPath>
                            <pattern
                              id="pattern"
                              preserveAspectRatio="none"
                              width="100%"
                              height="100%"
                              viewBox="0 0 14 21"
                            >
                              <image
                                width="14"
                                height="21"
                                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAVCAYAAAB2Wd+JAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIzSURBVDhPPZRdbtRAEIR7xt6ETQQSR+AG3IGL8cBpeOYEXAAJ8YDEEyCECIKw/2vPH1/1eNdRpcf2VFV3jbXh4/uXLQSzEKNFFiEC1RAdkXtdpZmdU7NTqjaXYrEZfzxstVop1So7KrW1jlp9B6IGmnUZ1p1VKBLom67rK9SB2RDpzJlhcWSpDfzHobtcXfXWyXKEsLhGPWCfb3B1iKreor/Qm36JOPj8rCt8aXQBbYHkFWeRcEXFAmvysxX9UiC26I4XAa3dn9oqs6v1JSRZi0zYFhODZ8iFehWAJTfdK+kLmVsColU55hqdmNtg2QaIBO2vuLzVLuLhAdE8pJnNqY021cFmRJILDX7gcnCiu+rI6EfBCHMJEAyCalxwaV/kHpBaFvRkNeA4lWhnAcIZV2Gq6mBEYPTZRS4MnHN2ZycWek6oq0UXoR6oxzzYsQgrnqt1kavllO12VDieqsiqxgfcWxZ5D3mXR9vmFfUGMYTnZCklpQrBZ4Ls8+G8QI4ibiD+mVf2e761h3ltv/Zkr3NzQGycrKB7JZvAReDIvJt04+Sv52fMCOGCvKQrZ7U+sT4R1h7iBue/abCHabDvp5HjIJieqJSFwGyRuTr+pQWsH8G34729+/nC4pmNruyJBg/lQJWI1ietEd3J7XRvnzfP7cPuDqK3w88CEHmiSkjP1Y1mPDDbI6Qfh6f25XTn5x7evH31uvQP03Sm/kn6p9Y//FnJpie2nW6YbW2fwLas7T/OkRbd5Ec2QAAAAABJRU5ErkJggg=="
                              />
                            </pattern>
                            <clipPath id="clip-path-3">
                              <path
                                id="Trazado_59652"
                                data-name="Trazado 59652"
                                d="M664.526-878a37.674,37.674,0,0,0-4.018,5.766c-.673,1.1-1.528,2.734-2.069,3.726a27.534,27.534,0,0,0-1.6,3.365.819.819,0,0,0,.2.736s1.776-1.069,2.213-1.375a21.837,21.837,0,0,1,3.214-1.818c1.238-.593,2.473-1.191,3.721-1.761,1.008-.459,2.061-.781,3.089-1.182a.3.3,0,0,0,.157-.417c-.834-1.64-1.844-2.824-2.978-4.678-.475-.777-.959-1.547-1.445-2.318a.3.3,0,0,0-.256-.14.3.3,0,0,0-.219.1"
                                fill="none"
                              />
                            </clipPath>
                            <clipPath id="clip-path-4">
                              <rect
                                id="Rectángulo_321"
                                data-name="Rectángulo 321"
                                width="14.697"
                                height="15.76"
                                transform="translate(655.802 -879.095)"
                                fill="none"
                              />
                            </clipPath>
                            <pattern
                              id="pattern-2"
                              preserveAspectRatio="none"
                              width="100%"
                              height="100%"
                              viewBox="0 0 16 17"
                            >
                              <image
                                width="16"
                                height="17"
                                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHXSURBVDhPnZRrTiMxEIR7nMciONTedc/ABTgJQlohsYgkTMi8bI/3q7YT/jNSpdtjV1W77UlXSrE/j7/LJQebcmdTCRbXYql0VqwzfmpsT9aYuZV3peuegl5q8bJ2NoMEOTeyFmaixom5iElcN44lC8FcQAuiyKiLcHWWS1pF0jwEkG4xeO4Cco5OAIogaStyxCnmrc1ER9K4vpPoTUDbEFaI1bWWOd/IW8YtT0TmlbuAmlcrCJQXfPEQtzamnecTkKtKjyu5m5CXbavA3UXcOOkS9+Q7J45ykwhEr0iVyb1V2SrYOOk873He25gFOWsxVSnSD+W1od9wgcP4YIfp3vrlzs6RCmjU1PbppNYfb6yLBE5OaAIf8y/7XHbWU/5A6d6g1sy68Jvg9wKoXzpmF/iCqJJrk3ACWRChuesGCtdjztxgRRd4XfZ2ouSB0gdvFNcaqPxKFmoVOuaVsaIunAs8z3f2wjb+so1/9ODIEfYI6vsYW+erYL3yV2FFFxhx/oAg8hvkd7Z0YHygHycEeoQuxIGjnBDzI4es++ACfu+ZkNuZXhwhH8lPKZBvfPzZhL4aRjCBKqCHpvB9IlQ/6xHBCziDHkjABYlHTE6QJej/Bz9/zP4Dlb3Jt1o2X+8AAAAASUVORK5CYII="
                              />
                            </pattern>
                            <clipPath id="clip-path-5">
                              <path
                                id="Trazado_59653"
                                data-name="Trazado 59653"
                                d="M653.849-893.858c-.234.347-.415.629-.633.966-.96,1.483-2.124,2.978-3.1,4.448-.75,1.126-1.625,2.386-2.4,3.516a.3.3,0,0,0,0,.333c.084.129.18.25.25.356a16.03,16.03,0,0,1,1.179,2.165c.612,1.334,1.413,2.444,2.087,3.7a.3.3,0,0,0,.53-.008,91.393,91.393,0,0,1,4.437-8.5c.419-.649.385-.582.793-1.23.032-.052.347-.566.5-.841a.3.3,0,0,0-.014-.319c-.856-1.249-1.707-2.341-2.519-3.635l-.616-.953a.293.293,0,0,0-.25-.136.3.3,0,0,0-.248.132"
                                fill="none"
                              />
                            </clipPath>
                            <clipPath id="clip-path-6">
                              <rect
                                id="Rectángulo_323"
                                data-name="Rectángulo 323"
                                width="11.951"
                                height="17.677"
                                transform="translate(646.653 -894.855)"
                                fill="none"
                              />
                            </clipPath>
                            <pattern
                              id="pattern-3"
                              preserveAspectRatio="none"
                              width="100%"
                              height="100%"
                              viewBox="0 0 13 19"
                            >
                              <image
                                width="13"
                                height="19"
                                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAATCAYAAABLN4eXAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGSSURBVDhPlVPLTgMxDJwkpZReudG/4MTnc0JwBYkvAHFErdrV0m5iZuymBXHCK6+fEztOkswM/yUHrT+fbNg8Yxzfsdu9YTt8YH/YYKp75HyF+cU1lssbXC5WWCxXAXp5vLOpZhxaw0R7qgm1AQ0Go1Qzlhp9cyAfkFWuJHrJOZOR+BkSbWmCShgKfZWSOIEksuKeFHv01fWZB9xdyc2YKzsTkVOsG3TW/hJzJRyg9iid3UtgFD2RTDYbIOYFu/6zYvhFAjjzdwJFhTOgJ3cKQOKejiDViNaOU6OuCfaYtBhC6A7SlDS9vieuJ7eT2ukUg+zTE9MxK4lnptZ+9xYVyJSV9qmSSKmanDAdptUV1floP5UOBzVa+pQcbcobrUlt/OsuVMqpgxSNk2d7miDVcuzB/8d4ZTUBI+ROJcQBF+8vwN4a0xTWBHWRTyB5vZaq+NgVCepAb7PfPeOTML4Br0i7JN51KYoxpTbtKfZzoN/f0+vD7X0uhZPj9ef4lLQeK7Z7w9eUMLSCsc0w8J2NlvENDaXXhDlNpjUAAAAASUVORK5CYII="
                              />
                            </pattern>
                            <clipPath id="clip-path-7">
                              <path
                                id="Trazado_59654"
                                data-name="Trazado 59654"
                                d="M657.7-888.11a29.221,29.221,0,0,0-2.781,5.149,57.539,57.539,0,0,0-2.12,6.2,9.817,9.817,0,0,0,.139,4.411,39.8,39.8,0,0,0,1.865,5.533.3.3,0,0,0,.524.054,58.46,58.46,0,0,0,3.168-5.027,24.675,24.675,0,0,1,3.389-4.748q.646-.749,1.316-1.479c.246-.268.619-.591.925-.906a.3.3,0,0,0,.034-.364c-.719-1.124-1.5-2.312-2.226-3.417-1.24-1.88-2.479-3.568-3.734-5.413a.3.3,0,0,0-.249-.132.3.3,0,0,0-.25.136"
                                fill="none"
                              />
                            </clipPath>
                            <clipPath id="clip-path-8">
                              <rect
                                id="Rectángulo_325"
                                data-name="Rectángulo 325"
                                width="13.658"
                                height="23.64"
                                transform="translate(651.571 -889.247)"
                                fill="none"
                              />
                            </clipPath>
                            <pattern
                              id="pattern-4"
                              preserveAspectRatio="none"
                              width="100%"
                              height="100%"
                              viewBox="0 0 15 24"
                            >
                              <image
                                width="15"
                                height="24"
                                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAYCAYAAAAlBadpAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJ8SURBVDhPZZRLctNAEIZbDz9ICqpgyYpbcCguwnW4QCrcgF0WWUGSwlSAGGxZbw3f3zOyk6Bya2Y0/T+6R3IWQrDLi/dhnILxs2AZY2Y98zEUhNng69yGKWOdsTZj+jm3R1eWxpEQ0aSRpyNAgXxODGntYIEwgGq8NDe2/JmDZhKFHMmNMp5dShZWCbIvyw6CQYBoPbiD/8FErJ1EBZNYZyLxZ6whcXDuxeoWEya3rMZRG/PZZg/rgAPviXAOc7C04l21Dg6KdjtUjg7YH1kfwc8v2Y4WdUTRcg9A8xmonKQ8H9IMyn1TFlXbTBD35pwZrBuXuitW2dbRRLVYrwd7AkblJw0DhAO9YVL2jqYQYOC53AgUmzm/JAnsZwutkqUamxQjnv8pnoIJrzOpdlNuHaMTsO0g1u5CxOw7uAAovB8Rm6qzU7MSWbTKPIH6qTyBVbMSHEhCO5KQkgWSYgQVkBa+34xFUgYtW/paGpJqEQCIX1AsoRlLa4bS2mHBuIRgOYNVU26tgKOS50bhRCqAmqGIBChKucV6tA1UgC2sOzZrt1Za3S9t36+t6ldWD8SIKs8FbMlxcOB8Kth+dbntUdm1K9s2a/vDuIfgAOkB0pOq6k8N+10Hu65e2+3+lW2ql3Zfn9tDd2ZbVHfdwios10QHUCC938dP8ivJd4d3dlOf2X27xr7sApAKTez4L1PjHof6EcHVwj5tgl1V5/a9XaKq2qmZ6KjP1SDR9+3fuBMk2xc/3tqmLu2GOq9Qv0b9G/XedUv72Zc4Ke0vRAeaVEPkbx/hf71vPn64fEBRB+bvWj7ZIgu2KkZ7kU22zoOtGReMeq43Mi+yL/8AfiwbEH8MQuYAAAAASUVORK5CYII="
                              />
                            </pattern>
                            <clipPath id="clip-path-9">
                              <path
                                id="Trazado_59655"
                                data-name="Trazado 59655"
                                d="M651.233-850.342l.031-.086c-.011.032-.022.061-.031.086m.031-.086.068-.187c-.02.055-.043.117-.068.187m.075-.205-.007.018.007-.019h0m0,0,.041-.111c-.012.034-.026.07-.041.111m.041-.111.018-.049-.018.049m.018-.049.084-.23-.084.23m-12.3-21.194a16.312,16.312,0,0,0,1.3,17.393,17.667,17.667,0,0,0,5.4,4.767,9.156,9.156,0,0,0,3.548,1.477c1.282.052,1.375-.573,1.855-1.9-.006.017,0,.007.015-.041l-.015.041c.005-.015.018-.048.034-.093l-.019.052c1.442-3.95,1.257-9.344-1.556-12.583a38.738,38.738,0,0,0-4.8-4.308c-1.856-1.53-3.408-3.427-5.3-4.907a.3.3,0,0,0-.183-.063.305.305,0,0,0-.27.163"
                                fill="none"
                              />
                            </clipPath>
                            <clipPath id="clip-path-10">
                              <rect
                                id="Rectángulo_327"
                                data-name="Rectángulo 327"
                                width="16.998"
                                height="25.912"
                                transform="translate(636.132 -873.203)"
                                fill="none"
                              />
                            </clipPath>
                            <pattern
                              id="pattern-5"
                              preserveAspectRatio="none"
                              width="100%"
                              height="100%"
                              viewBox="0 0 18 27"
                            >
                              <image
                                width="18"
                                height="27"
                                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAbCAYAAABxwd+fAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANsSURBVEhLpZU5bxRBEIXf9OzsLjYBZ0BiiQQLBCIg4RBIJEgQIRGCwBJI/AKLAIm/wV8gIcUZOTEiJAJhZK3tPefouXivZnZ9IgJKLnf3uPvrV9XV7eDjp1s1WgsCwFmvRsh+h4MwqBC5Cl22co0d/xaGIXq9HuKiwvWbXwLnqwBFLXcoKgdPz+kZPS4CTIsQ0zzEpIgwLbuY0bMqRE5A7j36HVJp3IsAQQjL97k2yPld0LQMMSNwTB/Rd3wXwzzCOAOKIm9BXHTYS8LlBuLYs00IlLpx0cEu1Q3yPn5lJ/B91CSDioDG98M4bl1qBVTr65BhdZBQ4ZDhDnyETd9vQKUmtXlqdoflSa48pWXAsKTGYZwH2PWOgBDbBP1MImz8vtiAPOVkBGhBqoX0hOBZ6cwnSjbbMVXIR/rGdpB18W14HhuDMw1IuyqxXmoITTlR3wSL2U+pUP1Mc+hK/Djr4cf0FL5OluA5pwXN1QSW0IywpCRQi1s4T9pCT8oORoRsJcvYTPqL/MicKVEiOXkepnJV0i3xYM0wwTMe+STrY5gtY8v3CIkQczNwTguCLdSp6ORqOcfyUmDmaMbjnrFuprnqp2M1tF1GqARqzdUE8acFNK3UWJUzlIR1kxAQF1TEdkroLk9wxlzxUtlKGUHt7hxbrXBCxt0S+oyLE7oUjVXJhO5Q4ZAbKPEtw8yVBxQQwokpd4y5MGEYMRfHUqbToo/oiU5qH0Tm5gCFIchcTUqPzRvYlK3qSXWmSm/C2jNX8iZ73WarH8LYCtrUk3bnibEviFqViyI4okgFJYgnJBfQYFImSBNGTBVWlASoXA5DZE6LfRXZQikzCBem6hugUTLVN93LY8KSsbI7KDix4M3OBeOOed2cyvzeZTpNOccVa+tYRaf7Zy0XntdE8asvJWpjfpMiXZfmKZGSo2pkbu32K0uehThXsgA07vWKUonep4Ogvb67unIDL28+5Y41Q9MFlaJG3fyF1EZ6tyykA2HtDewNeHDtId7cf827xhOTIoXGxXpCclMjqGZKwQHSwpwLnH7h3uW7eP9kHeeWmDPO1XOip7U0CAHHr1+Y0yaB/qHRLl1YxYfn77B25Q6qILSc6A6aaY6Af0t229Ls/uNkr4+3j17g87N1PF5ZRRl07FX4l6Kgtln/a8AfjbmgGUi0jr4AAAAASUVORK5CYII="
                              />
                            </pattern>
                            <clipPath id="clip-path-11">
                              <path
                                id="Trazado_59656"
                                data-name="Trazado 59656"
                                d="M667.827-854.7h0m.784-1.185.006-.008-.006.008m.006-.009h0m0,0h0m0,0h0m.943-14.027a42.429,42.429,0,0,0-9.011,5.584c-2.968,2.355-4.7,4.292-4.743,8.188a16.506,16.506,0,0,0,.764,5.546c.765,2.25.854,2.766,3.141,1.963a17.007,17.007,0,0,0,8.409-6.5c-.156.237-.29.439-.293.443l.358-.54.426-.645-.355.536a15.869,15.869,0,0,0,1.711-14.409.3.3,0,0,0-.284-.189.3.3,0,0,0-.123.026"
                                fill="none"
                              />
                            </clipPath>
                            <clipPath id="clip-path-12">
                              <rect
                                id="Rectángulo_329"
                                data-name="Rectángulo 329"
                                width="17.295"
                                height="23.782"
                                transform="translate(654.763 -871.002)"
                                fill="none"
                              />
                            </clipPath>
                            <pattern
                              id="pattern-6"
                              preserveAspectRatio="none"
                              width="100%"
                              height="100%"
                              viewBox="0 0 19 25"
                            >
                              <image
                                width="19"
                                height="25"
                                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAZCAYAAADTyxWqAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJwSURBVEhLrZXPahNRFMa/uTNpbbVYXLgQFAW7EV0ILhQkuPEviBahUHSrqCiCG8GdL6CgLyB9AJ/CBxDUnSuRgqYmbcw0yfy7ft+dOzFabRrbDw7nzuSe3z3n5MxMYK3F3dfztp+HSIsQuQ2QWeO8fpMvaL80vC5lAwuE5pnRxZd4D771ptBKJrCWRogzg25u0CM8KQgmoLKMcX+adQcDDtYQJKuhk4Xo5REzjJARIiu4JWemyi4rCFSgsiG4MncQ7zvY++4UPvUmsZxOopHW8J3ZtQleZ+nKMCEkoVeQC/Zt0AHOijI7B+sS8JXZfe7T6JcJa2QRVmiCtuk7LLlLuA7o0frM2h1CU49TmoMpaegHBaYhWiy5QVvhtaCrDF5l+Wu8jgUkaJ1wmXqa6I9jvIcNiSckDFD/fgjOjU2CWlw3eb/lwLzPsgXt0GKCYu7bCJPUYW5KbVmS+uYClZ2HKcsmTfC2h/8dVkmNVhncWI6KNw9XyR0PUxtGwDRE8hxUB1bDDfpcawYFLrMu15vDhjWAahTKuUp5LyMi4WjoX906rNIQFOypZkxzl/F6fFglB9WCCPqCwP+HVRr01T+b21NZ8rGZ2Z2AAdcPHcW7B0+3D9tVm8DLawuIgn89AVsSQ/lSfHN1EQf37UcQ6GU1ltifgc/xqn4Fl06c9JMydmZuFpx/fvYi7tXPc6k3XIkfv0xjsHRhHg/PXXZsW1QHjIRVZVGMOTA9g7eLd3DrdB1RyG9IyEGlVRoB47PigY+On8KH+09w5sicm9PfDvLaBMbNJsTC4Tl8vP0YL27cxN7p3awyRGA2giT33dwZAT8BuKpoBHJa9scAAAAASUVORK5CYII="
                              />
                            </pattern>
                          </defs>
                          <g
                            id="Grupo_4984"
                            data-name="Grupo 4984"
                            transform="translate(-857 -13621.425)"
                          >
                            <g
                              id="Grupo_4983"
                              data-name="Grupo 4983"
                              transform="translate(-0.053)"
                            >
                              <path
                                id="Trazado_59542"
                                data-name="Trazado 59542"
                                d="M117.185,123.815l-.295-.025c-2.517-.195-4.045-.418-4.045-1.858,0-1.538,2.243-2.112,3.657-2.112,1.491,0,3.379.28,3.909,1.624a.92.92,0,0,0,1.216.384.759.759,0,0,0,.48-1c-.867-2.355-3.537-2.849-5.624-2.849-2.235,0-5.559,1.048-5.559,3.935,0,3.122,3.07,3.366,5.778,3.582l.114.01c2.1.171,3.911.318,3.911,1.809,0,2.223-3.634,2.287-4.049,2.287-1.045,0-3.529-.178-4.054-1.828a.754.754,0,0,0-.532-.571,1.155,1.155,0,0,0-1.088.245.76.76,0,0,0-.21.78c.645,2.346,3.573,3.178,5.884,3.178,2.745,0,5.951-1.077,5.951-4.111,0-3.009-2.893-3.258-5.444-3.478"
                                transform="translate(746.291 13558.634)"
                                fill="#007168"
                              />
                              <path
                                id="Trazado_59543"
                                data-name="Trazado 59543"
                                d="M132.02,129.581c-2.752,0-4.675-2.075-4.675-5.047a4.42,4.42,0,0,1,3.744-4.735,5.7,5.7,0,0,1,.81-.057,6.359,6.359,0,0,1,.833.056,4.663,4.663,0,0,1,3.9,4.736c0,2.972-1.9,5.047-4.616,5.047m.942-11.485a8.3,8.3,0,0,0-2.127,0,6.3,6.3,0,0,0-5.352,6.379c0,4.033,2.688,6.85,6.537,6.85a6.517,6.517,0,0,0,6.459-6.85,6.45,6.45,0,0,0-5.517-6.38"
                                transform="translate(746.291 13558.634)"
                                fill="#007168"
                              />
                              <path
                                id="Trazado_59544"
                                data-name="Trazado 59544"
                                d="M154.383,118.181a.971.971,0,0,0-1.083.475l-4.57,7.175-4.6-7.165a.932.932,0,0,0-1.04-.5.922.922,0,0,0-.661.945v11.271a.912.912,0,0,0,1.823,0v-8.211l3.619,5.64a.947.947,0,0,0,.831.533.968.968,0,0,0,.861-.517l3.628-5.674v8.229a.912.912,0,0,0,1.823,0V119.114a.923.923,0,0,0-.63-.933"
                                transform="translate(746.291 13558.634)"
                                fill="#007168"
                              />
                              <path
                                id="Trazado_59545"
                                data-name="Trazado 59545"
                                d="M170.8,118.183a.876.876,0,0,0-1.155.472l-4.736,9.623-4.848-9.658a.935.935,0,0,0-1.265-.439.847.847,0,0,0-.464,1.15l5.716,11.356a.948.948,0,0,0,.82.588h.018a.952.952,0,0,0,.828-.529l5.646-11.433a.871.871,0,0,0-.56-1.13"
                                transform="translate(746.291 13558.634)"
                                fill="#82b558"
                              />
                              <path
                                id="Trazado_59546"
                                data-name="Trazado 59546"
                                d="M174.46,118.723v11.7a.876.876,0,0,0,.919.887.888.888,0,0,0,.943-.887v-11.7a.931.931,0,0,0-1.862,0"
                                transform="translate(746.291 13558.634)"
                                fill="#82b558"
                              />
                              <path
                                id="Trazado_59547"
                                data-name="Trazado 59547"
                                d="M190.7,119.124a.865.865,0,0,0-.917-.872H179.646a.864.864,0,0,0-.663.275.885.885,0,0,0-.224.6.851.851,0,0,0,.887.872h4.147v10.428a.893.893,0,0,0,.9.922.923.923,0,0,0,.941-.922c0-1.761-.005-3.537-.01-5.313-.005-1.709-.009-3.418-.01-5.115h4.166a.865.865,0,0,0,.917-.872"
                                transform="translate(746.291 13558.634)"
                                fill="#82b558"
                              />
                              <path
                                id="Trazado_59548"
                                data-name="Trazado 59548"
                                d="M199.795,126.2h-5.524l2.771-5.525Zm-1.953-7.782a.927.927,0,0,0-1.622,0l-5.913,11.651a.807.807,0,0,0,.443,1.093,1.067,1.067,0,0,0,.449.1.805.805,0,0,0,.755-.455l1.53-2.985H200.6l1.471,2.922a.877.877,0,0,0,.785.49,1.018,1.018,0,0,0,.91-.445.745.745,0,0,0-.031-.788Z"
                                transform="translate(746.291 13558.634)"
                                fill="#82b558"
                              />
                              <path
                                id="Trazado_59549"
                                data-name="Trazado 59549"
                                d="M215.906,129.424h-7.121V118.957a.923.923,0,0,0-1.843,0v11.232a.833.833,0,0,0,.941.921h8.023a.971.971,0,0,0,.7-.257.812.812,0,0,0,.247-.586.867.867,0,0,0-.946-.843"
                                transform="translate(746.291 13558.634)"
                                fill="#82b558"
                              />
                            </g>
                            <g
                              id="Grupo_4982"
                              data-name="Grupo 4982"
                              transform="translate(255.812 14515.415)"
                            >
                              <g id="Grupo_4961" data-name="Grupo 4961">
                                <g
                                  id="Grupo_4960"
                                  data-name="Grupo 4960"
                                  clip-path="url(#clip-path)"
                                >
                                  <g id="Grupo_4959" data-name="Grupo 4959">
                                    <g
                                      id="Grupo_4958"
                                      data-name="Grupo 4958"
                                      clip-path="url(#clip-path-2)"
                                    >
                                      <rect
                                        id="Rectángulo_318"
                                        data-name="Rectángulo 318"
                                        width="13.881"
                                        height="20.374"
                                        transform="translate(639.027 -884.349)"
                                        fill="url(#pattern)"
                                      />
                                    </g>
                                  </g>
                                </g>
                              </g>
                              <g id="Grupo_4965" data-name="Grupo 4965">
                                <g
                                  id="Grupo_4964"
                                  data-name="Grupo 4964"
                                  clip-path="url(#clip-path-3)"
                                >
                                  <g id="Grupo_4963" data-name="Grupo 4963">
                                    <g
                                      id="Grupo_4962"
                                      data-name="Grupo 4962"
                                      clip-path="url(#clip-path-4)"
                                    >
                                      <rect
                                        id="Rectángulo_320"
                                        data-name="Rectángulo 320"
                                        width="14.697"
                                        height="15.76"
                                        transform="translate(655.802 -879.095)"
                                        fill="url(#pattern-2)"
                                      />
                                    </g>
                                  </g>
                                </g>
                              </g>
                              <g id="Grupo_4969" data-name="Grupo 4969">
                                <g
                                  id="Grupo_4968"
                                  data-name="Grupo 4968"
                                  clip-path="url(#clip-path-5)"
                                >
                                  <g id="Grupo_4967" data-name="Grupo 4967">
                                    <g
                                      id="Grupo_4966"
                                      data-name="Grupo 4966"
                                      clip-path="url(#clip-path-6)"
                                    >
                                      <rect
                                        id="Rectángulo_322"
                                        data-name="Rectángulo 322"
                                        width="11.951"
                                        height="17.677"
                                        transform="translate(646.653 -894.855)"
                                        fill="url(#pattern-3)"
                                      />
                                    </g>
                                  </g>
                                </g>
                              </g>
                              <g id="Grupo_4973" data-name="Grupo 4973">
                                <g
                                  id="Grupo_4972"
                                  data-name="Grupo 4972"
                                  clip-path="url(#clip-path-7)"
                                >
                                  <g id="Grupo_4971" data-name="Grupo 4971">
                                    <g
                                      id="Grupo_4970"
                                      data-name="Grupo 4970"
                                      clip-path="url(#clip-path-8)"
                                    >
                                      <rect
                                        id="Rectángulo_324"
                                        data-name="Rectángulo 324"
                                        width="13.658"
                                        height="23.64"
                                        transform="translate(651.571 -889.247)"
                                        fill="url(#pattern-4)"
                                      />
                                    </g>
                                  </g>
                                </g>
                              </g>
                              <g id="Grupo_4977" data-name="Grupo 4977">
                                <g
                                  id="Grupo_4976"
                                  data-name="Grupo 4976"
                                  clip-path="url(#clip-path-9)"
                                >
                                  <g id="Grupo_4975" data-name="Grupo 4975">
                                    <g
                                      id="Grupo_4974"
                                      data-name="Grupo 4974"
                                      clip-path="url(#clip-path-10)"
                                    >
                                      <rect
                                        id="Rectángulo_326"
                                        data-name="Rectángulo 326"
                                        width="16.998"
                                        height="25.912"
                                        transform="translate(636.132 -873.203)"
                                        fill="url(#pattern-5)"
                                      />
                                    </g>
                                  </g>
                                </g>
                              </g>
                              <g id="Grupo_4981" data-name="Grupo 4981">
                                <g
                                  id="Grupo_4980"
                                  data-name="Grupo 4980"
                                  clip-path="url(#clip-path-11)"
                                >
                                  <g id="Grupo_4979" data-name="Grupo 4979">
                                    <g
                                      id="Grupo_4978"
                                      data-name="Grupo 4978"
                                      clip-path="url(#clip-path-12)"
                                    >
                                      <rect
                                        id="Rectángulo_328"
                                        data-name="Rectángulo 328"
                                        width="17.295"
                                        height="23.782"
                                        transform="translate(654.763 -871.002)"
                                        fill="url(#pattern-6)"
                                      />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </v-img>

                      <v-card-text class="pb-0 pt-3">
                        <v-list class="bg-white pa-0 mb-5">
                          <!-- <p
                            class="mx-1 text-center font-weight-medium accent--text"
                          >
                            {{ $t("sectores.bioseguridadtext1") }}
                          </p>
 -->
                          <v-list-item-group
                            v-for="(item, i) in bioseguridad"
                            :key="i"
                            class="d-flex justify-start align-start pa-0 my-3"
                          >
                            <v-list-item-icon class="pt-1 ma-0">
                              <v-icon size="8">{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content
                              class="d-flex align-start pa-0 ma-0"
                            >
                              <v-list-item-subtitle
                                class="d-flex align-start text-left font-weight-medium ma-0"
                              >
                                {{ $t(`${item.title}`) }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item-group>
                        </v-list>
                        <!-- <div class="d-flex justify-start align-start">
                              <v-img
                                class="mt-1 mr-2"
                                aspect-ratio="2"
                                contain
                                height="10"
                                width="10"
                                src="@/assets/formas/biro-blue-round-confetti.png"
                              ></v-img>

                              <p class="mx-1 text-left">
                                {{ $t("sectores.bioseguridadtext1") }}
                              </p>
                            </div>
                            <div class="d-flex justify-start align-start">
                              <v-img
                                class="mt-1 mr-2"
                                aspect-ratio="2"
                                contain
                                height="10"
                                width="10"
                                src="@/assets/formas/biro-blue-round-confetti.png"
                              ></v-img>
                              <p class="mx-1 text-left">
                                {{ $t("sectores.bioseguridadtext2") }}
                              </p>
                            </div>
                            <div class="d-flex justify-start align-start">
                              <v-img
                                class="mt-1 mr-2"
                                aspect-ratio="2"
                                contain
                                height="10"
                                width="10"
                                src="@/assets/formas/biro-blue-round-confetti.png"
                              ></v-img>
                              <p class="mx-1 text-left">
                                {{ $t("sectores.bioseguridadtext3") }}
                              </p>
                            </div>

                            <div class="d-flex justify-start align-start">
                              <v-img
                                class="mt-1 mr-2"
                                aspect-ratio="2"
                                contain
                                height="10"
                                width="10"
                                src="@/assets/formas/biro-blue-round-confetti.png"
                              ></v-img>
                              <p class="mx-1 text-left">
                                {{ $t("sectores.bioseguridadtext4") }}
                              </p>
                            </div>
                            <div class="d-flex justify-start align-start">
                              <v-img
                                class="mt-1 mr-2"
                                aspect-ratio="2"
                                contain
                                height="10"
                                width="10"
                                src="@/assets/formas/biro-blue-round-confetti.png"
                              ></v-img>
                              <p class="mx-1 text-left">
                                {{ $t("sectores.bioseguridadtext5") }}
                              </p>
                            </div>
                            <div class="d-flex justify-start align-start">
                              <v-img
                                class="mt-1 mr-2"
                                aspect-ratio="2"
                                contain
                                height="10"
                                width="10"
                                src="@/assets/formas/biro-blue-round-confetti.png"
                              ></v-img>
                              <p class="mx-1 text-left">
                                {{ $t("sectores.bioseguridadtext6") }}
                              </p>
                            </div> -->
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="210.866"
                          height="118.063"
                          viewBox="0 0 210.866 118.063"
                          class="pa-1 ma-2"
                        >
                          <text
                            id="PORCINO"
                            class="sectores-icons"
                            transform="translate(7.312 45.893)"
                            fill="#2c569F"
                            font-size="8"
                            font-family="SegoeUI, Segoe UI"
                          >
                            <tspan x="0" y="0">PORCINO</tspan>
                          </text>
                          <path
                            id="Trazado_59657"
                            data-name="Trazado 59657"
                            d="M126.805,360.333l-.1-.066c-.436.2-.881.388-1.307.612a5.389,5.389,0,0,0-2.87,3.451,7.932,7.932,0,0,0-.162,3.1c.061.484.151.964.238,1.506.408-.184.773-.317,1.11-.508a4.326,4.326,0,0,0,2.043-2.9c.406-1.716.7-3.461,1.047-5.194m-25.655-.06c.247,1.436.465,2.816.726,4.187a7.118,7.118,0,0,0,1.1,2.848,3.963,3.963,0,0,0,2.315,1.571c.022-.072.042-.116.051-.162a11.64,11.64,0,0,0,.266-3.048c-.028-.433.227-.714.6-.683a.558.558,0,0,1,.5.589,12.615,12.615,0,0,1-.334,3.618c-.334,1.562-.706,3.117-.972,4.692a4.317,4.317,0,0,0,.782,3.5c.848,1.084,1.682,2.182,2.565,3.234a6.526,6.526,0,0,0,7.223,2.227,6.669,6.669,0,0,0,3.351-2.409c.722-.88,1.387-1.811,2.125-2.675a4.622,4.622,0,0,0,1.063-3.9c-.19-1.207-.437-2.407-.719-3.594a15.019,15.019,0,0,1-.573-4.946A6.562,6.562,0,0,1,123,361.254a8.983,8.983,0,0,1,3.309-2.052c.226-.088.452-.174.679-.261,0-.034-.007-.068-.01-.1a1.985,1.985,0,0,0-.465-.029c-.654.117-1.315.214-1.956.391a6.61,6.61,0,0,0-4.43,3.55.574.574,0,0,1-.8.356,19.477,19.477,0,0,0-4.089-.721,19.727,19.727,0,0,0-6.56.694c-.546.16-.685.079-.953-.445a6.3,6.3,0,0,0-2.108-2.411,9.4,9.4,0,0,0-4.343-1.427,1.207,1.207,0,0,0-.351.069.484.484,0,0,0,.226.166c.548.231,1.11.431,1.638.7a12.181,12.181,0,0,1,1.4.875.558.558,0,0,1,.124.794.543.543,0,0,1-.765.137c-.078-.05-.152-.11-.228-.165a8.716,8.716,0,0,0-2.169-1.1m27.011-.9c-.167.748-.352,1.492-.5,2.244-.237,1.229-.4,2.476-.683,3.693-.539,2.316-1.726,4.062-4.083,4.705.138.6.278,1.189.406,1.778a13.168,13.168,0,0,1,.377,3.24,5.029,5.029,0,0,1-1,2.954c-.957,1.252-1.922,2.5-2.949,3.692a7.2,7.2,0,0,1-4.683,2.562,7.568,7.568,0,0,1-7.1-2.812c-.913-1.09-1.783-2.22-2.652-3.348a5.529,5.529,0,0,1-1.008-4.291c.172-1.258.445-2.5.678-3.772-.239-.092-.526-.189-.8-.312a5.572,5.572,0,0,1-3.021-3.645,30.823,30.823,0,0,1-.836-4.1c-.155-.867-.365-1.725-.55-2.587v-.58c.353-.891.879-1.264,1.691-1.141a18.752,18.752,0,0,1,2.121.406,7.651,7.651,0,0,1,4.937,3.676c.107.192.224.145.368.115.814-.167,1.622-.393,2.444-.489a19.814,19.814,0,0,1,7.75.5c.191.054.274-.009.368-.174a7.2,7.2,0,0,1,2.581-2.648,10.66,10.66,0,0,1,4.258-1.359,1.5,1.5,0,0,1,1.884,1.117Z"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59658"
                            data-name="Trazado 59658"
                            d="M113.964,380.631c.427-.073.863-.113,1.28-.225a2.031,2.031,0,0,0,1.641-2.32,3.929,3.929,0,0,0-1.568-2.817,2.146,2.146,0,0,0-2.756.031,3.987,3.987,0,0,0-1.526,2.753,1.983,1.983,0,0,0,1.193,2.189,5.053,5.053,0,0,0,1.736.389m-.063,1.119a5.422,5.422,0,0,1-1.993-.387,3.083,3.083,0,0,1-1.984-3.267,4.931,4.931,0,0,1,2.38-3.991,2.985,2.985,0,0,1,3.323.007A4.916,4.916,0,0,1,118,378.341a2.984,2.984,0,0,1-1.7,2.887,5.1,5.1,0,0,1-2.4.522"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59659"
                            data-name="Trazado 59659"
                            d="M109.187,373.283a.579.579,0,0,1-.015-1.156.578.578,0,0,1,.015,1.156"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59660"
                            data-name="Trazado 59660"
                            d="M118.731,372.127a.579.579,0,0,1,.017,1.156.579.579,0,0,1-.017-1.156"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59661"
                            data-name="Trazado 59661"
                            d="M105.507,363.609a.55.55,0,0,1-.554-.559.549.549,0,1,1,1.1-.013.553.553,0,0,1-.542.572"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59662"
                            data-name="Trazado 59662"
                            d="M112.125,378.373a7.725,7.725,0,0,1,.256-.855.5.5,0,0,1,.639-.249.552.552,0,0,1,.373.6,5.494,5.494,0,0,1-.226.86.514.514,0,0,1-.614.315.611.611,0,0,1-.428-.673"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59663"
                            data-name="Trazado 59663"
                            d="M115.8,378.38c-.008.388-.179.606-.438.668a.514.514,0,0,1-.61-.326,5.64,5.64,0,0,1-.223-.861.553.553,0,0,1,.382-.6.5.5,0,0,1,.636.26,8.556,8.556,0,0,1,.253.855"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <line
                            id="Línea_130"
                            data-name="Línea 130"
                            x2="42.327"
                            transform="translate(3.384 33.849)"
                            fill="none"
                            stroke="#2c569F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                            stroke-dasharray="0 1.969"
                          />
                          <path
                            id="Trazado_59664"
                            data-name="Trazado 59664"
                            d="M136.6,389.317h0m-45.28,0h0"
                            transform="translate(-89.905 -355.468)"
                            fill="none"
                            stroke="#2c569F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                          />
                          <text
                            id="AVICULTURA"
                            class="sectores-icons"
                            transform="translate(81.172 45.893)"
                            fill="#2c569F"
                            font-size="8"
                            font-family="SegoeUI, Segoe UI"
                          >
                            <tspan>AVICULTURA</tspan>
                          </text>
                          <path
                            id="Trazado_59665"
                            data-name="Trazado 59665"
                            d="M208.833,361.992a2.078,2.078,0,0,0-1.172-.839c-.06.437-.118.854-.176,1.282a2.106,2.106,0,0,0,1.348-.443m-5.148-6.524,1.079.5a5.934,5.934,0,0,1,.564-.23,1.768,1.768,0,0,1,2.122.748,2.8,2.8,0,0,1,.362,1.967,7.849,7.849,0,0,1-.386,1.361c-.075.213.053.239.2.3a15.942,15.942,0,0,1,1.448.677,1.993,1.993,0,0,1,.823,1.014.592.592,0,0,1-.163.731,3.26,3.26,0,0,1-2.488.862.5.5,0,0,0-.488.194,3.937,3.937,0,0,1-1.551,1.109c-.114.05-.228.1-.371.159.053.1.1.2.15.286a7.113,7.113,0,0,1,.6,6.278,11.469,11.469,0,0,1-2.885,4.535.706.706,0,0,1-.43.236.806.806,0,0,1-.5-.239c-.162-.177-.075-.388.081-.561.346-.385.716-.755,1.036-1.159a9.683,9.683,0,0,0,1.965-4.074,6.081,6.081,0,0,0-1.031-4.912c-.485-.688-.432-.839.37-1.185a7.82,7.82,0,0,0,1.089-.514,2.492,2.492,0,0,0,1.265-2.54,2.663,2.663,0,0,0-1.747-2.184,3.333,3.333,0,0,0-3.167.257,1.41,1.41,0,0,0-.328.264,17.058,17.058,0,0,1-5.519,3.859,21.206,21.206,0,0,1-6.408,1.871,18.049,18.049,0,0,1-7.295-.525c-.091-.026-.184-.047-.29-.073a9.7,9.7,0,0,0-.549,2.413,9.988,9.988,0,0,0,1.545,6.394,11.125,11.125,0,0,0,4.419,4.033,12.855,12.855,0,0,0,7.208,1.412,12.407,12.407,0,0,0,5.661-1.942c.16-.1.312-.215.476-.312a.552.552,0,0,1,.752.1.443.443,0,0,1-.147.679c-.459.3-.92.606-1.407.866a13.556,13.556,0,0,1-5.563,1.59c-.116.007-.231.025-.384.043.121.341.237.667.354.991.042.119.085.237.131.355.1.257.127.614.327.744s.582.04.884.044c.206,0,.411-.008.616.005a.505.505,0,0,1,.527.477.494.494,0,0,1-.528.475q-1.466.016-2.93,0a.482.482,0,0,1-.524-.472c0-.267.195-.454.514-.483.076-.006.154,0,.262,0-.022-.087-.033-.152-.055-.214-.188-.525-.4-1.042-.558-1.575-.086-.295-.249-.387-.564-.4a13.251,13.251,0,0,1-11-7.051,10.66,10.66,0,0,1-.444-8.576.646.646,0,0,0-.026-.426,8.177,8.177,0,0,1-.728-2.873c0-.054-.006-.107,0-.161a.482.482,0,0,1,.47-.463.476.476,0,0,1,.547.378c.055.288.052.586.112.874.087.426.207.846.323,1.31.445-.592.844-1.137,1.26-1.671a8.24,8.24,0,0,1,.6-.655.581.581,0,0,1,.817-.123c.24.193.234.488-.032.754a14.008,14.008,0,0,0-1.865,2.455.959.959,0,0,0-.052.106,14.742,14.742,0,0,0,3.032.6,19.24,19.24,0,0,0,9.493-1.6,17.577,17.577,0,0,0,5.066-3.178,6.061,6.061,0,0,0,.453-.454,4.439,4.439,0,0,1,6.237-.162.817.817,0,0,1,.086.123,2.193,2.193,0,0,0-.157-2.067.709.709,0,0,0-.891-.161,4.131,4.131,0,0,0-.526.334.573.573,0,0,1-.861-.09c-.025-.028-.045-.059-.069-.087a.82.82,0,0,0-1.415-.01c-.382.43-.6.45-1.064.094a1.814,1.814,0,0,0-.159-.118c-.608-.38-1.134-.241-1.334.4a9.582,9.582,0,0,0-.142,1.159.791.791,0,0,1-.245.475.5.5,0,0,1-.775-.318,2.746,2.746,0,0,1,.571-2.3,1.814,1.814,0,0,1,2.216-.375c.1.05.2.1.238.122l1.109-.505Z"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59666"
                            data-name="Trazado 59666"
                            d="M191.455,374.4a7.1,7.1,0,0,0,6.691-5.081,6.131,6.131,0,0,0-.049-3.331,1.3,1.3,0,0,1-.052-.235.477.477,0,0,1,.409-.536.5.5,0,0,1,.59.33,8.637,8.637,0,0,1,.29,1.28,7.037,7.037,0,0,1-1.938,5.886,8.354,8.354,0,0,1-5.441,2.651,8.706,8.706,0,0,1-6.372-1.753,7.454,7.454,0,0,1-2.759-4.062c-.139-.5.18-.764.737-.656.8.154,1.6.293,2.41.43.372.064.576.255.546.546s-.274.454-.662.41c-.578-.065-1.151-.155-1.8-.245.232.422.435.812.662,1.189a.394.394,0,0,0,.274.105,16.2,16.2,0,0,0,5.533-.484,2.525,2.525,0,0,1,.281-.073.531.531,0,0,1,.632.311.45.45,0,0,1-.334.6c-.462.139-.931.266-1.406.361a17.755,17.755,0,0,1-3.784.3c-.065,0-.13,0-.2,0-.024.029-.048.058-.073.086.106.072.219.137.315.217a7.573,7.573,0,0,0,2.863,1.513.64.64,0,0,0,.311.026,10.219,10.219,0,0,0,4.006-1.974,8.45,8.45,0,0,0,.768-.8.578.578,0,0,1,.785-.173c.261.17.283.465.056.756a7.743,7.743,0,0,1-2.628,2.089c-.22.112-.443.218-.665.326"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59667"
                            data-name="Trazado 59667"
                            d="M188.284,370.354c-.156.008-.312.026-.468.023a.533.533,0,0,1-.586-.481c0-.265.216-.463.556-.476a18.238,18.238,0,0,0,3.215-.374,15.894,15.894,0,0,0,3.26-1.083c.112-.053.224-.108.341-.152a.549.549,0,0,1,.723.213.457.457,0,0,1-.274.648c-.578.255-1.156.516-1.754.728a16.723,16.723,0,0,1-5.013.954"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59671"
                            data-name="Trazado 59671"
                            d="M203.651,360.135a.514.514,0,0,1,.5.5.508.508,0,0,1-.541.454.5.5,0,0,1-.5-.491.528.528,0,0,1,.543-.46"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <line
                            id="Línea_131"
                            data-name="Línea 131"
                            x2="42.327"
                            transform="translate(83.197 33.849)"
                            fill="none"
                            stroke="#2c569F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                            stroke-dasharray="0 1.969"
                          />
                          <path
                            id="Trazado_59668"
                            data-name="Trazado 59668"
                            d="M216.413,389.317h0m-45.28,0h0"
                            transform="translate(-89.905 -355.468)"
                            fill="none"
                            stroke="#2c569F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                          />
                          <text
                            id="RUMIANTES"
                            class="sectores-icons"
                            transform="translate(163.758 45.893)"
                            fill="#2c569F"
                            font-size="8"
                            font-family="SegoeUI, Segoe UI"
                          >
                            <tspan x="0" y="0">RUMIANTES</tspan>
                          </text>
                          <path
                            id="Trazado_59680"
                            data-name="Trazado 59680"
                            d="M278.486,382h-6.061a1.316,1.316,0,0,0,1.274.879c1.166.006,2.332,0,3.5,0a1.4,1.4,0,0,0,1.289-.883m-8.306-20.31c-.005-.007-.01-.017-.018-.021l-.342-.167a4.507,4.507,0,0,1-2.03-2.058c-.053-.1-.192-.157-.292-.235a1.07,1.07,0,0,0-.185.306,7,7,0,0,0-.149,1.045,2.788,2.788,0,0,0,2.465,2.873c.181-.571.362-1.144.551-1.743m11.1,1.78a4.979,4.979,0,0,0,1.55-.78,2.267,2.267,0,0,0,.9-1.849,8.251,8.251,0,0,0-.135-1.289c-.02-.124-.14-.231-.215-.346-.1.094-.233.168-.294.284a4.487,4.487,0,0,1-2.185,2.1c-.067.031-.13.072-.182.1.191.6.374,1.184.563,1.784m-.667,14.621a1.324,1.324,0,0,1,.1-.145,7.151,7.151,0,0,0,1.672-6.034,52.173,52.173,0,0,0-1.294-5.929c-.123-.453-.258-.9-.394-1.371-.16.078-.3.133-.423.207a4.477,4.477,0,0,0-2.186,3.84,15.077,15.077,0,0,0,1.084,6.478c.126.323.326.615.478.928.322.664.635,1.332.965,2.026m-20.114-15.054a.258.258,0,0,0,.023-.055,2.233,2.233,0,0,1,2.751-1.864,13.81,13.81,0,0,1,3.052.775c.034.013.07.02.133.038-.042-.216-.086-.409-.119-.6a5.464,5.464,0,0,1,.149-2.16,1.041,1.041,0,0,1,.875-.86,1.014,1.014,0,0,1,1.144.591,3.768,3.768,0,0,0,2.036,1.938.339.339,0,0,0,.41-.077,2.835,2.835,0,0,1,1.9-.748c.847-.015,1.693-.008,2.54,0a.463.463,0,0,1,.523.445c.007.278-.2.461-.533.462-.788,0-1.576,0-2.364,0a2.192,2.192,0,0,0-2.2,1.676c-.115.373-.223.75-.341,1.145l.3.142a5.075,5.075,0,0,1,2.742,3.527.443.443,0,0,1-.314.563c-.236.065-.431-.07-.538-.34a11.716,11.716,0,0,0-.607-1.432,3.636,3.636,0,0,0-1.852-1.569c-.165.587-.336,1.17-.494,1.757a50.4,50.4,0,0,0-1.184,5.52,7.15,7.15,0,0,0,1.685,6.058c.038.045.066.1.122.184.142-.376.239-.7.385-1,.219-.448.492-.869.7-1.319a13.039,13.039,0,0,0,.58-1.417,15.718,15.718,0,0,0,.844-4.743,3.437,3.437,0,0,1,.024-.393.418.418,0,0,1,.441-.395.425.425,0,0,1,.413.457c0,.454-.018.909-.054,1.361a17.29,17.29,0,0,1-.909,4.242c-.015.044-.027.09-.038.128.608-.072,1.2-.158,1.8-.208a.435.435,0,0,1,.458.609c-.089.228-.283.273-.5.3-.529.072-1.058.152-1.584.244a1.485,1.485,0,0,0-1.137.933,8.769,8.769,0,0,0-.87,2.932,2.209,2.209,0,0,0,.018.514.717.717,0,0,0,.69.658c.135.012.272.014.408.014q3.445,0,6.891,0c.117,0,.234,0,.35-.009a.727.727,0,0,0,.758-.782,3.836,3.836,0,0,0-.116-1.165c-.244-.794-.547-1.569-.849-2.342a1.1,1.1,0,0,0-.833-.692c-.552-.114-1.108-.2-1.663-.3-.076-.014-.156,0-.233-.018a.451.451,0,0,1-.413-.493.414.414,0,0,1,.485-.4c.541.055,1.079.14,1.618.213.056.008.11.019.159.027-.212-.808-.45-1.594-.623-2.395a13.351,13.351,0,0,1-.287-4.451,5.265,5.265,0,0,1,3.187-4.513,6.6,6.6,0,0,0-.749-1.968,2.116,2.116,0,0,0-1.645-.85c-.252-.011-.5,0-.758-.005a.454.454,0,1,1-.019-.907,3.47,3.47,0,0,1,2.779.824.265.265,0,0,0,.23.027,3.491,3.491,0,0,0,1.933-1.617c.064-.113.121-.23.185-.344a1.061,1.061,0,0,1,1.148-.591,1.079,1.079,0,0,1,.884.891,5.043,5.043,0,0,1-.009,2.751l.328-.114a10.8,10.8,0,0,1,3.353-.735,2.107,2.107,0,0,1,2.262,1.828.7.7,0,0,0,.046.11v.91c-.051.245-.092.493-.155.735a4.975,4.975,0,0,1-3.271,3.574.452.452,0,0,1-.65-.253.47.47,0,0,1,.352-.6,4.188,4.188,0,0,0,2.179-1.692,4.126,4.126,0,0,0,.666-2.343,1.255,1.255,0,0,0-1.322-1.363,10.013,10.013,0,0,0-3.373.764,7.812,7.812,0,0,0-1.865.908,10.406,10.406,0,0,1-1.412.711c.136.476.283.975.421,1.476.126.456.233.917.371,1.368a.365.365,0,0,0,.24.224c.744.078,1.491.134,2.237.194.1.008.2,0,.291.009a.459.459,0,0,1,.437.474.434.434,0,0,1-.472.426c-.641-.023-1.283-.063-1.923-.1-.163-.01-.325-.033-.525-.055.114.559.227,1.086.328,1.615a17.127,17.127,0,0,1,.4,3.6,7.8,7.8,0,0,1-2.287,5.248.722.722,0,0,0-.217.657,3.827,3.827,0,0,1-.039,1.17,1.457,1.457,0,0,1-1.114,1.191.476.476,0,0,0-.342.319,2.371,2.371,0,0,1-1.594,1.515,3.041,3.041,0,0,1-.695.063c-1.041.006-2.084-.03-3.124.011a2.377,2.377,0,0,1-2.426-1.615.555.555,0,0,0-.3-.273,1.64,1.64,0,0,1-1.2-1.478,3.609,3.609,0,0,1,.022-.935.62.62,0,0,0-.2-.6,8.044,8.044,0,0,1-2.255-4.516,10.14,10.14,0,0,1,.117-2.956c.158-.994.352-1.981.537-3.005-.368.033-.74.075-1.113.1q-.641.037-1.283.048a.444.444,0,0,1-.5-.429c-.011-.267.186-.454.5-.477.823-.062,1.647-.121,2.47-.2a.312.312,0,0,0,.228-.167c.271-.946.527-1.9.785-2.849a.3.3,0,0,0,0-.085c-1.317-.5-2.433-1.432-3.808-1.8a11.48,11.48,0,0,0-2.767-.557,1.276,1.276,0,0,0-1.382,1.424,4.159,4.159,0,0,0,2.682,3.912c.073.028.148.051.219.082a.468.468,0,0,1,.3.579.44.44,0,0,1-.6.273,5.024,5.024,0,0,1-2.584-1.929,4.908,4.908,0,0,1-.847-2.229,1.074,1.074,0,0,0-.05-.171Z"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59681"
                            data-name="Trazado 59681"
                            d="M274.326,364.491a4.074,4.074,0,0,1-2.54-1.511.45.45,0,0,1,.048-.626.421.421,0,0,1,.624.058,3.248,3.248,0,0,0,2.161,1.184.447.447,0,0,1,.4.476c-.017.27-.216.428-.694.419"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59682"
                            data-name="Trazado 59682"
                            d="M277.772,364.491A4.082,4.082,0,0,1,275.247,363a.457.457,0,0,1,.036-.65.426.426,0,0,1,.642.087,3.44,3.44,0,0,0,1.436,1,2.858,2.858,0,0,0,.621.142c.308.044.5.229.483.493s-.218.425-.693.415"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59688"
                            data-name="Trazado 59688"
                            d="M278.353,377.519a3.121,3.121,0,0,1-1.007,1.831.368.368,0,0,1-.552-.053.43.43,0,0,1-.036-.579,4.336,4.336,0,0,0,.359-.474,5.163,5.163,0,0,0,.361-.878c.08-.272.239-.445.482-.417s.4.236.393.57"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59683"
                            data-name="Trazado 59683"
                            d="M273.092,376.944c.067.076.271.2.292.35a2.643,2.643,0,0,0,.668,1.318c.219.265.225.537.019.718s-.449.142-.665-.109a3.252,3.252,0,0,1-.856-1.652.5.5,0,0,1,.542-.625"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59684"
                            data-name="Trazado 59684"
                            d="M271.077,370.307c0,.292.006.584,0,.876a.435.435,0,1,1-.867.018q-.02-.891,0-1.783a.435.435,0,1,1,.867.013c.008.292,0,.584,0,.876"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59689"
                            data-name="Trazado 59689"
                            d="M280.691,370.324c0,.282.008.564,0,.846-.013.31-.187.489-.448.486s-.42-.183-.423-.5c-.005-.564-.006-1.128,0-1.692,0-.319.162-.5.425-.5s.426.177.448.487c0,.02,0,.04,0,.06q0,.408,0,.816Z"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <line
                            id="Línea_132"
                            data-name="Línea 132"
                            x2="42.327"
                            transform="translate(164.87 33.849)"
                            fill="none"
                            stroke="#2c569F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                            stroke-dasharray="0 1.969"
                          />
                          <path
                            id="Trazado_59679"
                            data-name="Trazado 59679"
                            d="M298.087,389.317h0m-45.28,0h0"
                            transform="translate(-89.905 -355.468)"
                            fill="none"
                            stroke="#2c569F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                          />
                          <text
                            id="INDUSTRIA_"
                            class="sectores-icons"
                            data-name="INDUSTRIA "
                            transform="translate(4.376 107.063)"
                            fill="#2c569F"
                            font-size="8"
                            font-family="SegoeUI, Segoe UI"
                          >
                            <tspan x="0" y="0">INDUSTRIA</tspan>
                          </text>
                          <text
                            id="ALIMENTARIA"
                            class="sectores-icons"
                            transform="translate(0 116.063)"
                            fill="#2c569F"
                            font-size="8"
                            font-family="SegoeUI, Segoe UI"
                          >
                            <tspan x="0" y="0">ALIMENTARIA</tspan>
                          </text>
                          <path
                            id="Trazado_59669"
                            data-name="Trazado 59669"
                            d="M107.371,420.635a5.22,5.22,0,0,0-5.215,5.215v.929h21.137v-.929a5.221,5.221,0,0,0-5.215-5.215Zm10.826,10.81,3.785-3.785h-7.57Zm-15.246-1.966a1.484,1.484,0,0,0,0,2.967h15l-2.967-2.967Zm15.49,2.967H122.5a1.484,1.484,0,0,0,0-2.967h-1.09Zm-15.49.881a2.365,2.365,0,1,1,0-4.729h11.154l-.939-.938H101.874a.6.6,0,0,1-.6-.6V425.85a6.1,6.1,0,0,1,6.1-6.1h10.707a6.1,6.1,0,0,1,6.1,6.1v1.209a.6.6,0,0,1-.6.6h-.346l-.888.888.513.077a2.364,2.364,0,0,1-.354,4.7Z"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59685"
                            data-name="Trazado 59685"
                            d="M120.931,436.218a2.479,2.479,0,0,1-1.695-.656,1.647,1.647,0,0,0-2.3,0,2.517,2.517,0,0,1-3.389,0,1.646,1.646,0,0,0-2.3,0,2.519,2.519,0,0,1-3.391,0,1.646,1.646,0,0,0-2.3,0,2.515,2.515,0,0,1-3.388,0,1.621,1.621,0,0,0-1.149-.467.441.441,0,1,1,0-.881,2.478,2.478,0,0,1,1.694.656,1.647,1.647,0,0,0,2.3,0,2.515,2.515,0,0,1,3.39,0,1.648,1.648,0,0,0,2.3,0,2.515,2.515,0,0,1,3.39,0,1.648,1.648,0,0,0,2.3,0,2.515,2.515,0,0,1,3.39,0,1.65,1.65,0,0,0,2.3,0,2.475,2.475,0,0,1,1.695-.657.441.441,0,0,1,0,.881,1.62,1.62,0,0,0-1.149.467,2.479,2.479,0,0,1-1.695.656"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59690"
                            data-name="Trazado 59690"
                            d="M102.267,438.647a5.235,5.235,0,0,0,5.1,4.14h10.707a5.233,5.233,0,0,0,5.1-4.14l.066-.316H102.2Zm5.1,5.021a6.1,6.1,0,0,1-6.085-5.752.44.44,0,0,1,.439-.465h22a.44.44,0,0,1,.44.465,6.1,6.1,0,0,1-6.086,5.752Z"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59672"
                            data-name="Trazado 59672"
                            d="M108.162,425.212a.6.6,0,1,1,.6-.6.6.6,0,0,1-.6.6"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59673"
                            data-name="Trazado 59673"
                            d="M112.724,425.212a.6.6,0,1,1,.6-.6.6.6,0,0,1-.6.6"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59674"
                            data-name="Trazado 59674"
                            d="M117.286,425.212a.6.6,0,1,1,.6-.6.6.6,0,0,1-.6.6"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59675"
                            data-name="Trazado 59675"
                            d="M110.653,423.2a.6.6,0,1,1,.6-.6.6.6,0,0,1-.6.6"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59676"
                            data-name="Trazado 59676"
                            d="M115.215,423.2a.6.6,0,1,1,.6-.6.6.6,0,0,1-.6.6"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <line
                            id="Línea_133"
                            data-name="Línea 133"
                            x2="42.327"
                            transform="translate(3.684 95.02)"
                            fill="none"
                            stroke="#2c569F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                            stroke-dasharray="0 1.969"
                          />
                          <path
                            id="Trazado_59692"
                            data-name="Trazado 59692"
                            d="M136.9,450.488h0m-45.28,0h0"
                            transform="translate(-89.905 -355.468)"
                            fill="none"
                            stroke="#2c569F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                          />
                          <text
                            id="CUNICULTURA"
                            class="sectores-icons"
                            transform="translate(159.866 107.063)"
                            fill="#2c569F"
                            font-size="8"
                            font-family="SegoeUI, Segoe UI"
                          >
                            <tspan x="0" y="0">CUNICULTURA</tspan>
                          </text>
                          <path
                            id="Trazado_59686"
                            data-name="Trazado 59686"
                            d="M287.307,440.264a1.484,1.484,0,0,0,1.983-.821,1.568,1.568,0,0,0-.687-2.012,6.847,6.847,0,0,1-1.3,2.833m-13.488-23.2.034.078a4.593,4.593,0,0,1,1.995.721.339.339,0,0,0,.448-.01,13.164,13.164,0,0,1,4.974-2.115c.39-.076.783-.135,1.177-.2a.977.977,0,0,0-.77-.657,5.131,5.131,0,0,0-2.17-.1,12.219,12.219,0,0,0-4.375,1.472c-.449.25-.876.542-1.313.815m13.889,19.192a7.82,7.82,0,0,0-.491-2.656,13.1,13.1,0,0,0-1.672-3.064,11.94,11.94,0,0,0-5.4-4.447,24.452,24.452,0,0,0-2.672-.748c-.283-.074-.447.06-.579.347a6.046,6.046,0,0,1-3.588,3.281,8.091,8.091,0,0,1-3.071.41c-.1,0-.265.036-.3.11a6.553,6.553,0,0,0-.752,4.2,7.241,7.241,0,0,0,1.639,3.6c.6.709.392.941-.188,1.347a5.3,5.3,0,0,0-1.654,1.722c-.538.957-.169,1.7.891,1.794l.056,0a4.166,4.166,0,0,0,2.344-.573,13.443,13.443,0,0,0,3.995-3.446.51.51,0,0,0,.054-.344c-.047-.376-.142-.747-.171-1.124a6.794,6.794,0,0,1,.7-3.561.472.472,0,0,1,.68-.253c.261.147.316.433.138.818a5.8,5.8,0,0,0-.365,3.983,3.329,3.329,0,0,0,1.33,2.127c.557.354,1.143.66,1.724.97.36.193.508.436.39.725s-.412.4-.785.2c-.626-.327-1.248-.666-1.849-1.038-.466-.288-.466-.313-.826.119a1.836,1.836,0,0,0-.166.234.815.815,0,0,0,.183,1.16,1.547,1.547,0,0,0,.42.229,5.542,5.542,0,0,0,4.223-.394,2.934,2.934,0,0,1,.736-.249,5.943,5.943,0,0,0,3.445-1.686,5.109,5.109,0,0,0,1.593-3.792M281.046,413.7c.351.088.711.15,1.052.27a1.871,1.871,0,0,1,1.337,1.4c.015.068.136.138.217.156.375.079.762.107,1.128.214a1.967,1.967,0,0,1,1.163,3.142,6.855,6.855,0,0,1-2.188,2.191,13.62,13.62,0,0,1-6,2.282c-.159.019-.222.074-.232.251-.015.259-.071.516-.112.8.422.075.854.139,1.281.23a11.782,11.782,0,0,1,6.772,4.181,16.458,16.458,0,0,1,2.279,3.5,9.294,9.294,0,0,1,.933,3.73.365.365,0,0,0,.254.381,2.643,2.643,0,0,1,1.428,2.838,2.594,2.594,0,0,1-2.173,2.136,2.539,2.539,0,0,1-1.494-.278.318.318,0,0,0-.286.029,7.274,7.274,0,0,1-3.677,1.608,7.022,7.022,0,0,0-1.169.465,6.151,6.151,0,0,1-3.478.315,4.341,4.341,0,0,1-1.292-.535,1.855,1.855,0,0,1-.387-2.729,3.286,3.286,0,0,1,.336-.391c.319-.321.324-.355.028-.787l-.591.653a12.221,12.221,0,0,1-3.148,2.563,6.15,6.15,0,0,1-2.828.859,2.645,2.645,0,0,1-1.835-.6,2.054,2.054,0,0,1-.345-2.511,5.759,5.759,0,0,1,1.52-1.853c.137-.117.278-.228.43-.352a8.084,8.084,0,0,1-1.036-8.63c-.526-.183-1.045-.338-1.545-.544a6,6,0,0,1-2.134-1.423,3.18,3.18,0,0,1-.645-3.678c.216-.494.485-.965.747-1.436.185-.331.479-.418.729-.249s.268.444.1.774c-.262.515-.532,1.027-.755,1.559a2.028,2.028,0,0,0,.524,2.314,5.419,5.419,0,0,0,2.147,1.341,7.079,7.079,0,0,0,4.79.156,5.311,5.311,0,0,0,3.537-3.9,4.628,4.628,0,0,0,.124-1.035c.022-.494.132-.666.6-.7a12.173,12.173,0,0,0,4.545-1.289,8.627,8.627,0,0,0,3.1-2.313,3.655,3.655,0,0,0,.526-.982.667.667,0,0,0-.319-.871,2.816,2.816,0,0,0-.861-.323,6.838,6.838,0,0,0-2.895.149,13.173,13.173,0,0,0-4.791,2.2.559.559,0,0,1-.748.005,4.252,4.252,0,0,0-4.191-.552,10.022,10.022,0,0,0-3.7,2.311c-.105.1-.2.2-.307.3-.276.26-.565.275-.767.044a.529.529,0,0,1,.093-.773c.351-.336.7-.676,1.078-.981a9.725,9.725,0,0,1,4.123-2.091.611.611,0,0,0,.287-.159,13.019,13.019,0,0,1,7.5-3.345.351.351,0,0,0,.1-.039Z"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59687"
                            data-name="Trazado 59687"
                            d="M270.147,422.064a.845.845,0,0,1,.847.859.837.837,0,1,1-.847-.859"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59691"
                            data-name="Trazado 59691"
                            d="M280.822,430.559a1.293,1.293,0,0,1-.29.343c-.418.27-.857.507-1.29.753a.48.48,0,0,1-.65-.126.5.5,0,0,1,.11-.7,13.741,13.741,0,0,1,1.464-.84c.318-.153.647.108.656.568"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <line
                            id="Línea_134"
                            data-name="Línea 134"
                            x2="42.327"
                            transform="translate(165.171 94.823)"
                            fill="none"
                            stroke="#2c569F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                            stroke-dasharray="0 1.969"
                          />
                          <path
                            id="Trazado_59693"
                            data-name="Trazado 59693"
                            d="M298.387,450.291h0m-45.28,0h0"
                            transform="translate(-89.905 -355.468)"
                            fill="none"
                            stroke="#2c569F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                          />
                          <text
                            id="ACUICULTURA"
                            class="sectores-icons"
                            transform="translate(78.541 107.063)"
                            fill="#2c569F"
                            font-size="7"
                            font-family="SegoeUI, Segoe UI"
                          >
                            <tspan y="0">ACUICULTURA</tspan>
                          </text>
                          <path
                            id="Trazado_59670"
                            data-name="Trazado 59670"
                            d="M199.8,434.18c.482.47.933.911,1.388,1.349a.586.586,0,0,0,.959-.017,4.788,4.788,0,0,0,1.24-2.252,4.159,4.159,0,0,0,.117-1.384,12.687,12.687,0,0,1-3.7,2.3m-7.415-13.116c-.229.01-.458.011-.686.033a5,5,0,0,0-3.025,1.361c-.244.229-.309.521-.107.728.491.5,1.012.973,1.541,1.476a13.782,13.782,0,0,1,2.277-3.6m-4.438,14.345a5.038,5.038,0,0,0-6.151.011,5.025,5.025,0,0,0,6.151-.011m.879,6.863a4.727,4.727,0,0,0-.012-6,4.718,4.718,0,0,0,.012,6m17.241-15.6c-.15,0-.261-.005-.372,0a6.457,6.457,0,0,1-2.609-.346,15.342,15.342,0,0,1-1.733-.8.5.5,0,0,1-.181-.734.563.563,0,0,1,.757-.185c.083.041.159.094.24.139a6.121,6.121,0,0,0,4.3.726.4.4,0,0,0,.255-.195,13.828,13.828,0,0,0,1.119-4.611,5.878,5.878,0,0,0-.314-2.361,1.626,1.626,0,0,0-1.157-1.121,8.845,8.845,0,0,0-1.83-.316,13.63,13.63,0,0,0-5.136,1,.589.589,0,0,0-.441.536,5.926,5.926,0,0,0,.335,3.051c.152.393.04.7-.29.815s-.609-.049-.76-.445a6.831,6.831,0,0,1-.466-2.666c.006-.177,0-.355,0-.583-.444.252-.867.475-1.273.726a14.98,14.98,0,0,0-3.8,3.171,13.328,13.328,0,0,0-2.4,4.989,27.7,27.7,0,0,0-.934,6.865c0,.178,0,.357,0,.547.1.005.177.013.249.012a30.514,30.514,0,0,0,7.371-.916,12.613,12.613,0,0,0,7.208-4.457,19.979,19.979,0,0,0,1.871-2.841m2.846-5.077c-.1.514-.185,1.033-.31,1.542a17.976,17.976,0,0,1-3.918,7.494.534.534,0,0,0-.139.484,5.825,5.825,0,0,1-1.631,5.188,1.689,1.689,0,0,1-2.479.04c-.544-.521-1.081-1.052-1.619-1.581a.285.285,0,0,0-.334-.1,29.242,29.242,0,0,1-8.146,1.3c-.093,0-.186.009-.3.015.166.327.352.63.481.954a5.791,5.791,0,0,1-1.132,6.391,3.566,3.566,0,0,1-.424.345h-.336a5.847,5.847,0,0,1-1.7-6.283c.014-.041.018-.085.035-.165-.283.071-.535.146-.794.2a6.15,6.15,0,0,1-5.526-1.5c-.4-.358-.391-.635.008-1.008a6.272,6.272,0,0,1,7.318-.809c.078.045.158.086.259.14.039-.641.069-1.254.115-1.867a25.091,25.091,0,0,1,1.228-6.322.325.325,0,0,0-.1-.4c-.536-.5-1.058-1.022-1.583-1.539a1.6,1.6,0,0,1,.031-2.456,6.161,6.161,0,0,1,5.325-1.575.5.5,0,0,0,.447-.12,18.543,18.543,0,0,1,7.681-3.827c.667-.153,1.355-.219,2.035-.326.081-.012.163-.03.244-.045H205c.329.055.659.1.986.165a3.161,3.161,0,0,1,2.765,2.557c.049.22.106.439.16.658Z"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59677"
                            data-name="Trazado 59677"
                            d="M199.954,424.165a.537.537,0,0,1-.541-.543.556.556,0,0,1,1.112.027.544.544,0,0,1-.571.516"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <path
                            id="Trazado_59678"
                            data-name="Trazado 59678"
                            d="M204.355,420.786a.532.532,0,0,1-.542-.539.546.546,0,0,1,.546-.542.554.554,0,0,1,.56.559.542.542,0,0,1-.564.522"
                            transform="translate(-89.905 -355.468)"
                            fill="#2c569F"
                          />
                          <line
                            id="Línea_135"
                            data-name="Línea 135"
                            x2="42.327"
                            transform="translate(83.497 94.823)"
                            fill="none"
                            stroke="#2c569F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                            stroke-dasharray="0 1.969"
                          />
                          <path
                            id="Trazado_59694"
                            data-name="Trazado 59694"
                            d="M216.713,450.291h0m-45.28,0h0"
                            transform="translate(-89.905 -355.468)"
                            fill="none"
                            stroke="#2c569F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                          />
                        </svg>
                      </v-card-text>
                      <v-card-actions class="d-flex justify-center bottom-button">
                        <v-btn
                          color="accent"
                          elevation="0"
                          @click="reveal4 = false"
                          bottom
                          dark
                          fab
                          small
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expand-transition>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Sectores",
  data: () => ({
    reveal1: false,
    reveal2: false,
    reveal3: false,
    reveal4: false,
    reveal5: false,
    img: require("@/assets/img/marcas/logo1.png"),
    bioseguridad: [
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.bioseguridadtext1",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.bioseguridadtext2",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.bioseguridadtext3",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.bioseguridadtext4",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.bioseguridadtext5",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.bioseguridadtext6",
      },
    ],
    avicultura: [
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.aviculturatext4",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.aviculturatext5",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.aviculturatext6",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.aviculturatext8",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.aviculturatext10",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.aviculturatext11",
      },
    ],
    produccion: [
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.producciontext1",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.producciontext2",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.producciontext3",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.producciontext4",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.producciontext6",
      },
      {
        icon: "$vuetify.iconConfeti",
        title: "sectores.producciontext7",
      },
    ],
  }),
};
</script>

<style scoped>
.container {
  min-height: 100vh;
}

.ow-break-word {
  word-break: break-word;
}

.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}

.before-enter.card {
  opacity: 0;
  transform: translateY(50px);
  transition: all 1s ease-in-out;
}
/* 
      Si el elemento se cruza con la ventana gráfica, se agrega la clase antes de ingresar.
    */
.enter.card {
  opacity: 1;
  transform: translateY(0px);
}

.before-enter g {
  stroke-dasharray: 915;
  stroke-dashoffset: 915;
}

.enter g {
  stroke-dasharray: 915;
  stroke-dashoffset: 0;
  transition: all 5s ease-in-out;
}

.neftysGradient {
  background: rgb(44,86,159);
  background: linear-gradient(90deg, rgba(44,86,159,0.25) 0%, rgba(9,146,71,0.25) 53%);
}


.sectores-icons tspan {
  font-size: 9px;
}

.v-card--reveal.rounded-xl {
  padding: 20px;
}

.bottom-button {
  position: absolute;
  bottom: -30px;
  left: 50%;
  margin-left: -30px;
}

</style>
